module.exports = __webpack_public_path__ + "assets/img/FBR_Taenk_BedstItest_2020_GREEN_5.a6e66233.png";